/*
 * CommonReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */
import { fromJS } from 'immutable';
import {
  ADD_TO_CART_SUCCESS,
  ADD_PRIMARY_TO_CART_SUCCESS,
  BALANCE_PRODUCT_ADDTIONS,
  REMOVE_FROM_CART_SUCCESS,
  REMOVE_FROM_STATE,
  ADD_VARIANT_IDS_OF_PRODUCTS_TO_HIDE,
  SET_ATC_STATUS_ADDING,
  SET_ATC_STATUS_ADDED,
  RESET_ATC_STATUS,
} from './constants';

// The initial state of the Init container
export const initialState = fromJS({
  productAdditions: [],
  variantIDsOfProductsToHide: [],
  popup: {},
  embedded: {},
  atcStatus: {},
});

function initReducer(state = initialState, action) {
  let productAdditions = state.get('productAdditions', {});
  if (productAdditions.size === 0) productAdditions = {};

  switch (action.type) {
    case ADD_TO_CART_SUCCESS:
      const addSuccessData = {
        product_id: action.datapack.product_id,
        variant_id: action.datapack.variant_id,
        product_title: action.datapack.product_title,
        variant_title: action.datapack.variant_title,
        quantity: +1,
      };
      if (action.datapack.widgetID) {
        if (productAdditions[action.datapack.widgetID])
          return state.setIn(['productAdditions'], {
            ...productAdditions,
            [action.datapack.widgetID]: productAdditions[
              action.datapack.widgetID
            ].concat(addSuccessData),
          });
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          [action.datapack.widgetID]: [addSuccessData],
        });
      }

      if (productAdditions.default)
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          default: productAdditions.default.concat(addSuccessData),
        });
      return state.setIn(['productAdditions'], {
        ...productAdditions,
        default: [addSuccessData],
      });

    case ADD_PRIMARY_TO_CART_SUCCESS:
      const addPrimarySuccessData = {
        product_id: action.datapack.product_id,
        variant_id: action.datapack.variant_id,
        product_title: action.datapack.product_title,
        variant_title: action.datapack.variant_title,
        quantity: +1,
      };
      if (action.datapack.widgetID) {
        if (productAdditions[action.datapack.widgetID])
          return state.setIn(['productAdditions'], {
            ...productAdditions,

            [action.datapack.widgetID]: productAdditions[
              action.datapack.widgetID
            ].concat(addPrimarySuccessData),
          });
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          [action.datapack.widgetID]: [addPrimarySuccessData],
        });
      }
      if (productAdditions.default)
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          default: productAdditions.default.concat(addPrimarySuccessData),
        });
      return state.setIn(['productAdditions'], {
        ...productAdditions,
        default: [addPrimarySuccessData],
      });

    case REMOVE_FROM_STATE:
      const removeStateData = {
        product_id: action.product_id,
        variant_id: action.variant_id,
        // product_title: action.product_title,
        variant_title: action.variant_title,
        quantity: -action.old_quantity,
      };
      if (action.datapack.widgetID) {
        if (productAdditions[action.datapack.widgetID])
          return state.setIn(['productAdditions'], {
            ...productAdditions,
            [action.datapack.widgetID]: productAdditions[
              action.datapack.widgetID
            ].concat(removeStateData),
          });
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          [action.datapack.widgetID]: [removeStateData],
        });
      }
      if (productAdditions.default)
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          default: productAdditions.default.concat(removeStateData),
        });
      return state.setIn(['productAdditions'], {
        ...productAdditions,
        default: [removeStateData],
      });

    case REMOVE_FROM_CART_SUCCESS:
      const removeSuccessData = {
        product_id: action.datapack.product_id,
        variant_id: action.datapack.variant_id,
        product_title: action.datapack.product_title,
        variant_title: action.datapack.variant_title,
        quantity: -1,
      };
      if (action.datapack.widgetID) {
        if (productAdditions[action.datapack.widgetID])
          return state.setIn(['productAdditions'], {
            ...productAdditions,
            [action.datapack.widgetID]: productAdditions[
              action.datapack.widgetID
            ].concat(removeSuccessData),
          });
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          [action.datapack.widgetID]: removeSuccessData,
        });
      }
      if (productAdditions.default)
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          default: productAdditions.default.concat(removeSuccessData),
        });
      return state.setIn(['productAdditions'], {
        ...productAdditions,
        default: [removeSuccessData],
      });

    case BALANCE_PRODUCT_ADDTIONS:
      if (action.widgetID) {
        if (productAdditions[action.widgetID])
          return state.setIn(['productAdditions'], {
            ...productAdditions,
            [action.widgetID]: productAdditions[action.widgetID].concat(
              action.addtions,
            ),
          });
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          [action.widgetID]: action.addtions,
        });
      }
      if (productAdditions.default)
        return state.setIn(['productAdditions'], {
          ...productAdditions,
          default: productAdditions.default.concat(action.addtions),
        });
      return state.setIn(['productAdditions'], {
        ...productAdditions,
        default: action.addtions,
      });

    case ADD_VARIANT_IDS_OF_PRODUCTS_TO_HIDE:
      return state.update('variantIDsOfProductsToHide', obj =>
        obj.push(...action.ids),
      );
    case SET_ATC_STATUS_ADDING:
      return state
        .setIn(['atcStatus', 'adding'], true)
        .setIn(['atcStatus', 'added'], false)
        .setIn(['atcStatus', 'spVariantID'], action.spVariantID)
        .setIn(['atcStatus', 'widgetID'], action.widgetID);

    case SET_ATC_STATUS_ADDED:
      return state
        .setIn(['atcStatus', 'adding'], false)
        .setIn(['atcStatus', 'added'], true)
        .setIn(['atcStatus', 'spVariantID'], action.spVariantID)
        .setIn(['atcStatus', 'widgetID'], action.widgetID);

    case RESET_ATC_STATUS:
      return state
        .setIn(['atcStatus', 'adding'], false)
        .setIn(['atcStatus', 'added'], false)
        .setIn(['atcStatus', 'spVariantID'], action.spVariantID)
        .setIn(['atcStatus', 'widgetID'], action.widgetID);

    default:
      return state;
  }
}

export default initReducer;
